module.exports = __webpack_public_path__ + "assets/icon_vial.09beb29e.svg";